import fetchInstructionListsForPackages from './fetchInstructionListsForPackages';
import summarizeJobWorkInstructions from './summarizeJobWorkInstructions';

export default async function loadJobWorkInstructionStatus(client, jobId) {
  const packagesResponse = await client.get(
    `/work-instructions-package/job/${jobId}`
  );
  const packages = packagesResponse.data || [];

  if (packages.length === 0) {
    return {
      hasInstructions: false,
      instructionCount: 0,
    };
  }

  const instructionLists = await fetchInstructionListsForPackages(
    client,
    packages
  );

  return summarizeJobWorkInstructions(instructionLists);
}
